






















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ViewAllUsersModal extends Vue {
  showModal = false;
  @Prop() logins?: any[];

  fields: any[] = [{ key: 'users_firstName', label: 'Name', sortable: true }, { key: 'users_secondName', label: 'Surname', sortable: true }, { key: 'users_email', label: 'Email' }, { key: 'max', label: 'Last login', formatter: this.formatDate }, { key: 'count', label: 'Login count', sortable: true }]
    currentPage = 1
    perPage = 15

    formatDate (date: string) {
    // format date with time
      return date ? new Date(date).toLocaleString() : ''
    }

    get rows () {
      return this.logins?.length
    }

    get topLogins () {
      return this.logins?.length ? this.logins.filter((x: { count: number; }) => x.count > 0).slice(0, 20) : []
    }
}
